import { useAuth as e } from "../../hooks/useAuth.mjs";
import { permissionBatcher as t } from "../../utils/permissionBatcher.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { PermissionSlug as r } from "@maat/api-main/types";
//#region src/queries/state/useCheckPermission.ts
var i = (i) => {
	let { activeWorkspaceId: a, permissions: o } = e(), s = o.includes(r.Wildcard) || o.includes(i), { data: c, isLoading: l } = n({
		queryKey: [
			"permission",
			a,
			i
		],
		queryFn: () => t.fetch(i),
		staleTime: 300 * 1e3,
		enabled: !!a && !s
	});
	return s ? {
		hasPermission: !0,
		isLoading: !1
	} : {
		hasPermission: c?.allowed ?? !1,
		isLoading: l
	};
};
//#endregion
export { i as useCheckPermission };
